import React, { Component } from "react";
import { Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { PostData } from "../api/service";

// Renders a "message" block (photo + truncated text + Read more) driven by a
// backend notice type (e.g. PROGRAMME_OFFICER_MESSAGE, PRINCIPAL_MESSAGE).
export default class HomePageProfileMessage extends Component {
  state = { data: null, isLoaded: false };

  componentDidMount() {
    PostData(`/getnoticesbytypedept`, {
      dept_code: "NSS",
      type: this.props.type,
    })
      .then((resp) => {
        const data = Array.isArray(resp) && resp.length > 0 ? resp[0] : null;
        this.setState({ data, isLoaded: true });
      })
      .catch(() => this.setState({ data: null, isLoaded: true }));
  }

  __image = (d) => {
    if (!d) return null;
    const imgs = [];
    if (Array.isArray(d.featured_photo))
      imgs.push(...d.featured_photo.filter((f) => f && f.fileType === "image"));
    if (Array.isArray(d.upload_info))
      imgs.push(...d.upload_info.filter((f) => f && f.fileType === "image"));
    return imgs.length > 0 ? imgs[0].url : null;
  };

  __text = (html) => {
    if (!html) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    const txt = (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
    const limit = this.props.limit || 360;
    return txt.length > limit ? txt.slice(0, limit) : txt;
  };

  render() {
    const { data, isLoaded } = this.state;

    if (!isLoaded) {
      return (
        <Typography variant="body2" style={{ padding: 10, color: "#7F8C8D" }}>
          Loading . . .
        </Typography>
      );
    }

    if (!data) {
      return (
        <Typography variant="body2" style={{ padding: 10, color: "#7F8C8D" }}>
          No message available.
        </Typography>
      );
    }

    const img = this.__image(data);
    const text = this.__text(data.description);

    return (
      <div style={{ width: "100%", position: "relative", minHeight: "38vh" }}>
        {img && <img src={img} className="img-wrap-image" alt="" />}

        <div className="p-warp-image">
          <Typography
            variant="body2"
            gutterBottom
            style={{ textAlign: "justify", padding: 10, fontSize: 16 }}
          >
            {text}....<Link to={this.props.link}>Read more</Link>
          </Typography>
        </div>
      </div>
    );
  }
}
